module.exports = __webpack_public_path__ + "img/invoiceQueryAct.9eae26a6.png";